import {createContext} from 'react'

import type {NotificationsContext as ContextType} from './types'

export const NotificationsContext = createContext<ContextType>(null)
const globalContextKey_UNSAFE = Symbol('notifications-context')

type NotificationsProviderProps = {
  value: ContextType
  children: React.ReactNode
}

export const NotificationsProvider = ({value, children}: NotificationsProviderProps) => {
  // @ts-expect-error у типа window нет такого ключа, да в общем-то и не должно быть в типах, скрываем как можем
  window[globalContextKey_UNSAFE] = value
  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>
}
